export const rupee = (n) => `₹${Math.round(Number(n || 0)).toLocaleString("en-IN")}`;

export function waLink(number, text) {
  const num = (number || "918595672124").replace(/[^0-9]/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(text)}`;
}

export function productWaText(product) {
  const url = `${window.location.origin}/product/${product.slug}`;
  return `Hi LIVENEAT Organic, I am interested in:\n\nProduct: ${product.name}\nPrice: ₹${Math.round(product.price)}\n\nProduct Link: ${url}`;
}

export function cartWaText(items, totals) {
  let lines = "LIVENEAT Organic Cart\n\n";
  items.forEach((i) => {
    lines += `${i.name} (x${i.qty}) – ₹${Math.round(i.price * i.qty)}\n`;
  });
  lines += `\nSubtotal – ₹${Math.round(totals.subtotal)}`;
  if (totals.discount) lines += `\nDiscount – ₹${Math.round(totals.discount)}`;
  lines += `\nTotal – ₹${Math.round(totals.total)}`;
  lines += `\n\nCustomer requires assistance with this order.`;
  return lines;
}
